import React from 'react';
import styles from './index.module.scss';
import EcoTabSectionLR from 'eco-design/sections/eco-tab-section-l-r';
import EcoImg from 'eco-design/base/eco-img';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSection from 'eco-design/base/eco-section';
import { getIconList } from './config';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/i18n';

const SectionIconList = (type: 'a' | 'b' | 'c') => {
    const { locale } = getLocal();
    const list = getIconList(locale, type);
    return (
        <ul className="icon-ul-list">
            {list.map((item, index) => (
                <li className="icon-item" key={type + index}>
                    {item.icon()}
                    <p>{item.name}</p>
                </li>
            ))}
        </ul>
    );
};

interface InputPowerAcProProps {
    productName: 'ac' | 'ultra';
}
const InputPowerAcPro: React.FC<InputPowerAcProProps> = ({ productName }) => {
    const { t } = useLang('theProduct.InputPowerAcPro');
    const { locale } = getLocal();
    return (
        <section
            className={`${styles.InputPowerAcPro} GtmModuleData-section`}
            data-section-id="InputPowerAcPro"
            data-section-title={t(`acpro_${productName}_title`)}
        >
            <div className="label">{productName === 'ac' ? '' : t('acpro_label')}</div>
            <EcoSection className="section-text" title={t(`acpro_${productName}_title`)} subTitle={t(`acpro_${productName}_subtitle`)} />
            <div className="power-container">
                <EcoImg
                    className="power-bg"
                    pc={
                        locale === 'uk'
                            ? 'https://websiteoss.ecoflow.com/upload/image/1762137292227/pc-uk.jpg'
                            : 'https://websiteoss.ecoflow.com/upload/image/1745834381278/pc.jpg'
                    }
                    pad={
                        locale === 'uk'
                            ? 'https://websiteoss.ecoflow.com/upload/image/1762137292227/pc-uk.jpg'
                            : 'https://websiteoss.ecoflow.com/upload/image/1745834381278/pc.jpg'
                    }
                    h5={
                        locale === 'uk'
                            ? 'https://websiteoss.ecoflow.com/upload/image/1762137275438/m-uk.jpg'
                            : 'https://websiteoss.ecoflow.com/upload/image/1745834385062/m.jpg'
                    }
                />
                <div className="icon-list">
                    {/* <div className="title1">Electrical appliances</div> */}
                    {SectionIconList('a')}
                </div>
            </div>
        </section>
    );
};

export default InputPowerAcPro;
